import callAPiBase from './base';

const operatorsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/operatorList',
      method: 'GET',
      useToken: true,
      title: 'Operator - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/operatorCreate',
      method: 'POST',
      useToken: true,
      title: 'Operator - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/operatorUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Operator - Update',
      data,
    }),
  requestAccess: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/operatorRequest',
      method: 'POST',
      useToken: true,
      title: 'Operator - Request Access',
      data,
    }),
};

export { operatorsApi };
export default operatorsApi;
